module.exports = __webpack_public_path__ + "img/ser1.37051163.png";